export default {
	"vehicleType": {
		"vehicletypeCode": "车型编码",
		"vehicleLoad": "车型载重",
		"vehicleType": "车型种类",
		"cubage": "车型容积",
		"updateUser": "更新人",
		"uploadDt": "更新时间",
		"vehicleInformation": "车型信息",
		"vehicleLength": "长",
		"vehicleWidth": "宽",
		"vehicleHeight": "高"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/vehicleType/vehicleType.js